import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HlmToaster } from '@pagai-fe/ui';
import { LoaderService } from './shared/services/loader.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ThemeService } from './core/services/theme.service';
import { AnalyticsService } from './core/services/analytics.service';

/**
 * Root application component
 * Includes global loader overlay and toast notifications
 * User/tenant loading is handled by MainLayoutComponent (only after authentication)
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, HlmToaster],
  templateUrl: './app.html',
})
export class App {
  /** Loader service for global loading state */
  private readonly _loaderService = inject(LoaderService);
  /** Theme service - handles dark mode, injected to initialize on app start */
  private readonly _themeService = inject(ThemeService);
  /** Analytics service for Mixpanel tracking */
  private readonly _analyticsService = inject(AnalyticsService);

  /** Loading state signal for template binding */
  protected readonly isLoading = this._loaderService.isLoading();

  constructor() {
    // Initialize analytics on app startup
    this._analyticsService.init();
  }
}
